import { create } from 'zustand';
import type { Settings } from '../api/client';

interface AiSettingsState {
  aiEnabled: boolean;
  aiAcknowledged: boolean;
  customPrompts: Record<string, string> | null;
  isInitialized: boolean;
  loadFromSettings: (settings: Settings) => void;
  setAiEnabled: (enabled: boolean) => void;
  setAiAcknowledged: (acknowledged: boolean) => void;
  setCustomPrompt: (key: string, value: string | null) => void;
  setCustomPrompts: (prompts: Record<string, string> | null) => void;
}

export const useAiSettingsStore = create<AiSettingsState>((set, get) => ({
  aiEnabled: false,
  aiAcknowledged: false,
  customPrompts: null,
  isInitialized: false,

  loadFromSettings: (settings: Settings) => {
    set({
      aiEnabled: settings.ai_enabled ?? false,
      aiAcknowledged: settings.ai_acknowledged ?? false,
      customPrompts: settings.custom_prompts ?? null,
      isInitialized: true,
    });
  },

  setAiEnabled: (enabled: boolean) => {
    set({ aiEnabled: enabled });
  },

  setAiAcknowledged: (acknowledged: boolean) => {
    set({ aiAcknowledged: acknowledged });
  },

  setCustomPrompt: (key: string, value: string | null) => {
    const current = get().customPrompts ?? {};
    if (value === null) {
      const { [key]: _, ...rest } = current;
      set({ customPrompts: Object.keys(rest).length > 0 ? rest : null });
    } else {
      set({ customPrompts: { ...current, [key]: value } });
    }
  },

  setCustomPrompts: (prompts: Record<string, string> | null) => {
    set({ customPrompts: prompts });
  },
}));
